import { CircularProgress } from '@material-ui/core'
import { ToolExecutionState } from 'ducks/chatDrawer'
import React from 'react'
import { AutoDesignProgressItem } from './autoDesign/AutoDesignProgressItem'
import { AutoStringProgressItem } from './autoString/AutoStringProgressItem'
import { BatteryDesignAssistantProgressItem } from './batteryDesignAssistant/BatteryDesignAssistantProgressItem'
import { InverterDesignAssistantProgressItem } from './inverterDesignAssistant/InverterDesignAssistantProgressItem'

interface ToolProgressRendererProps {
  toolExecutionState: ToolExecutionState
  messageIndex: number
}

export const ToolProgressRenderer: React.FC<ToolProgressRendererProps> = ({ toolExecutionState, messageIndex }) => {
  switch (toolExecutionState.toolType) {
    case 'autoDesign':
      return <AutoDesignProgressItem toolExecutionState={toolExecutionState} messageIndex={messageIndex} />

    case 'autoString':
      return <AutoStringProgressItem toolExecutionState={toolExecutionState} messageIndex={messageIndex} />

    case 'batteryDesignAssistant':
      return <BatteryDesignAssistantProgressItem toolExecutionState={toolExecutionState} messageIndex={messageIndex} />

    case 'inverterDesignAssistant':
      return <InverterDesignAssistantProgressItem toolExecutionState={toolExecutionState} messageIndex={messageIndex} />

    default:
      // Fallback for unknown tool types - show a generic progress indicator
      return (
        <div style={{ padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '8px', marginTop: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {toolExecutionState.status === 'running' && (
              <>
                <CircularProgress size={24} />
                <span style={{ fontSize: '14px', color: '#666' }}>
                  {toolExecutionState.description || 'Processing...'}
                </span>
              </>
            )}
            {toolExecutionState.status === 'ready' && (
              <span style={{ fontSize: '14px', color: '#666' }}>{toolExecutionState.description || 'Ready'}</span>
            )}
            {toolExecutionState.status === 'completed' && (
              <span style={{ fontSize: '14px', color: '#4caf50' }}>
                ✓ {toolExecutionState.description || 'Completed'}
              </span>
            )}
            {toolExecutionState.status === 'error' && (
              <span style={{ fontSize: '14px', color: '#f44336' }}>
                {toolExecutionState.description || 'Error occurred'}
              </span>
            )}
          </div>
        </div>
      )
  }
}
